@if (item?.isRelativeUrl) {
	<a [routerLink]="item?.link">{{ item.label }}</a>
}
@if (!item?.isRelativeUrl) {
	<a [href]="item?.link" [target]="item?.openInSameTab ? '_self' : '_blank'">{{ item?.label }}</a>
}
